import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Daily sketch #1",
  "description": "",
  "published": "2006-06-07T00:00:00.000Z",
  "redirect_from": ["/blog/daily-sketch-1/swizec/406"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`So before the sidebar for these is created, here's the first one.`}</p>
    <p>{`This is also a guest character in Cthulhu episode 2.`}</p>
    <p><img parentName="p" {...{
        "src": "/includes/editor_upload/Image/sketches/kscan_0131.png",
        "alt": null
      }}></img></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      